"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgStore = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.174 2c.958 0 1.638.565 1.826 1.5l.925 3.997A3.76 3.76 0 0 1 20 11.557V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8.443a3.76 3.76 0 0 1-1.925-4.06L3 3.5c.188-.935.868-1.5 1.826-1.5h14.348ZM4.044 7.889 5 4h2.99l-.442 4.41A1.77 1.77 0 0 1 5.783 10a1.767 1.767 0 0 1-1.738-2.111ZM10.423 4 10 7.776A2.014 2.014 0 0 0 12 10a2.014 2.014 0 0 0 2-2.224L13.578 4h-3.155Zm5.587 0 .443 4.41A1.77 1.77 0 0 0 18.217 10a1.767 1.767 0 0 0 1.738-2.111L19 4h-2.99ZM6 11.994V20h12v-8.006a3.779 3.779 0 0 1-2-.708V15a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-3.714c-.57.41-1.258.666-2 .708ZM12 12c.73 0 1.413-.197 2-.539V14h-4v-2.539c.587.342 1.27.539 2 .539Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgStore);
//# sourceMappingURL=SvgStore.js.map